export const QUERY_KEY_RECORDINGS_UPLOADED = 'recordings-uploaded'
export const QUERY_KEY_DEVICE_RECORDINGS = 'device-recordings-by-period'
